/**
 * @generated SignedSource<<f6a09ec5e0088791f90155a200bfef78>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedLayout_viewer$data = {
  readonly itemRead: ReadonlyArray<{
    readonly serviceId?: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_item">;
  } | null> | null;
  readonly similarLandingItems?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_similarLandingItems">;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_user" | "PdpSharedLayout_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_viewer" | "PdpSharedLayout_viewer">;
  readonly " $fragmentType": "PdpRespCondensedLayout_viewer";
};
export type PdpRespCondensedLayout_viewer$key = {
  readonly " $data"?: PdpRespCondensedLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemIds"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedLayout_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespCondensedContainer_user"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedLayout_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemIds",
          "variableName": "itemIds"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "itemRead",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespCondensedContainer_item"
            }
          ],
          "type": "Item",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "similarLandingItems",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 12
            },
            {
              "kind": "Variable",
              "name": "isTrade",
              "variableName": "isTrade"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "useML",
              "value": true
            }
          ],
          "concreteType": "moreLikeThisItemConnection",
          "kind": "LinkedField",
          "name": "moreLikeThisItem",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespCondensedContainer_similarLandingItems"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "401acd079e4f8c644f0313284b9cf399";

export default node;
